import React, { useState, useEffect } from "react";
import {MinusIcon, PlusIcon, TrashIcon} from "@heroicons/react/outline";
// import { TrashIcon } from "@heroicons/react/outline";
import useGlobal from "../../../state/useGlobal";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import BigNumber from "bignumber.js";
import toast from "react-hot-toast";
import {
  ATTRIBUTE_CODE_COLOR,
  ATTRIBUTE_CODE_GRAVIUR,
  ATTRIBUTE_CODE_IS_GRAVIUR,
  LIMIT_CART_CALCULATOR
} from "../../../constants/common";
import Color from "./Options/Color";
import Gravur from "./Options/Gravur";
import { HandleImageURL } from "../../../helpers";
const Image = ({ src, alt }) => {
  const [errored, setErrored] = useState(false);

  if (errored) {
    return (
      <svg
        className="w-full h-full text-gray-300 bg-white border border-gray-200 rounded-md"
        preserveAspectRatio="none"
        stroke="currentColor"
        fill="none"
        viewBox="0 0 200 200"
        aria-hidden="true"
      >
        <path
          vectorEffect="non-scaling-stroke"
          strokeWidth="1"
          d="M0 0l200 200M0 200L200 0"
        ></path>
      </svg>
    );
  } else {
    return (
      <img
        className="flex-shrink-0 object-contain w-full h-full mx-auto"
        src={HandleImageURL(src)}
        alt={alt}
        onError={setErrored}
      />
    );
  }
};

export default function FakeCartItemConf({ item }) {
  /* eslint-disable no-unused-vars */
  const [globalState, globalActions] = useGlobal();
  const { t } = useTranslation();
  const { groupOrder } = globalState;
  const { calculator } = groupOrder;
  const { product, price, qty, options } = item;
  
  // Find Simple
  const { product_simples } = product;
  const [simpleProduct, setSimpleProduct] = useState(null);
  useEffect(() => {
    const getImage = (lastValues) => {
      const product = product_simples.find((product_simple) => {
        let find = true;
        for (
          let index = 0;
          index < product_simple.product_custom_attributes.length;
          index++
        ) {
          const element = product_simple.product_custom_attributes[index];
          if (element.value !== lastValues[element.attribute_code]) {
            return false;
          }
        }

        return find;
      });

      setSimpleProduct(product);
    };

    getImage(options);
  }, [options]); // eslint-disable-line react-hooks/exhaustive-deps
  
  const total = new BigNumber(price).multipliedBy(new BigNumber(qty));

  const handleOnRemove = async () => {
    globalActions.minusFromCart(item);
  };

  // const handleOnRemoveAllItem = async () => {
  //   globalActions.removeFromCart(item);
  //   toast(
  //     t(`"{{product_name}}" has been removed from your cart.`, {
  //       product_name: item.name,
  //     }),
  //     {
  //       id: item.id + "removeAll",
  //       icon: <TrashIcon className="w-8 h-8 text-fiery-rose-600" />,
  //     }
  //   );
  // };

  const handleOnAdd = async () => {
    if (item?.id === calculator?.product_id) {
      if (item?.qty < LIMIT_CART_CALCULATOR) {
        globalActions.addToCart(item);
      }
    } else {
      globalActions.addToCart(item);
    }
  };

  return (
    <li className="flex py-6">
      <div className="flex-shrink-0 w-16 overflow-hidden md:w-24 md:h-24">
        <Image src={simpleProduct?.product_image} alt={simpleProduct?.name} />
      </div>

      <div className="flex flex-col flex-1 ml-4 space-y-4">
        <div>
          <h3 className="font-medium text-gray-900 overflow-ellipsis">
            {product.name}
          </h3>
          {options &&
            Object.entries(options).map(([key, value]) => {
              const option = product?.configurable_product_options.find(
                (option) => option.attribute_code === key
              );
              const attribute_option = option?.attribute_options.find(
                (attribute_option) => attribute_option.value_index === value
              );

              switch (key) {
                case ATTRIBUTE_CODE_COLOR:
                  return value ? (
                    <Color key={key} value={value} item={item} />
                  ) : (
                    ""
                  );
                case ATTRIBUTE_CODE_GRAVIUR:
                  return value ? <Gravur key={key} value={value} /> : "";
                case ATTRIBUTE_CODE_IS_GRAVIUR:
                  return "";
                default:
                  return (
                    <p key={key} className="mt-1 text-gunmetal-black-500">
                      {attribute_option?.label}
                    </p>
                  );
              }
            })}
        </div>
        <div className="flex items-end justify-between flex-1 text-sm">
          <div className="flex items-end space-x-4 ">
            <div className="relative z-0 inline-flex rounded-lg shadow-sm bg-celadon-green-500 text-white">
              {qty === 1 ? (
                  <button
                      type="button"
                      onClick={handleOnRemove}
                      className={classNames({
                        "relative inline-flex items-center md:px-3 px-1.5 md:py-2 py-1 text-sm font-medium rounded-l-lg  border-r-2 border-white text-white focus:z-10 focus:outline-none ": true,
                      })}
                  >
                    <TrashIcon className="w-4 h-4"/>
                  </button>
              ) : (
                  <button
                      type="button"
                      onClick={handleOnRemove}
                      className={classNames({
                        "relative inline-flex items-center md:px-3 px-1.5 md:py-2 py-1 -ml-px text-sm font-medium border-r-2 border-white  focus:z-10 focus:outline-none ": true,
                      })}
                  >
                    <MinusIcon className="w-4 h-4"/>
                  </button>
              )}

              <button
                  type="button"
                  className="relative inline-flex items-center md:px-4 px-2.5 md:py-2 py-1.5 -ml-px text-xs font-medium border-celadon-green-500 focus:z-10 focus:outline-none "
              >
                {item?.qty}
              </button>
              <button
                  type="button"
                  onClick={handleOnAdd}
                  className={classNames({
                    "relative inline-flex items-center md:px-3 px-1.5 md:py-2 py-1 -ml-px text-sm font-medium border-l-2 border-white rounded-r-lg focus:z-10 focus:outline-none ": true,
                  })}
              >
                <PlusIcon className="w-4 h-4"/>
              </button>
            </div>
            <p className="hidden text-base text-gray-900 md:block">
              x {new BigNumber(price).toFormat(2).toString()} €
            </p>
            {/* <button
              type="button"
              onClick={handleOnRemoveAllItem}
              className="inline-flex items-center p-1 text-fiery-rose-600 hover:text-fiery-rose-700"
            >
              <TrashIcon className="w-6 h-6" />
            </button> */}
          </div>

          <p className="text-base font-medium text-gray-900 ">
            {total.toFormat(2).toString()} €
          </p>
        </div>
      </div>
    </li>
  );
}
